module.exports = __webpack_public_path__ + "static/imgs/circle-center.ab8277c.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/imgs/circle/circle-center.png
// module id = JAOo
// module chunks = 1